<template>
  <div class="pt80">
    <div class="container1200">
      <Navbar />
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">Página Inicial</el-breadcrumb-item>
        <el-breadcrumb-item>Detalhes do Pedido</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="order-detail" v-if="detail.order_id">
        <div class="order-list" v-if="detail.items && detail.items.length">
          <div class="order-item">
            <div>Número do pedido: {{ detail.order_sn }}</div>
            <div>Data do pedido: {{ detail.create_time }}</div>
            <div>Nome da empresa: {{ detail.company_name || '-' }}</div>
            <div>CNPJ: {{ detail.tax_number || '-' }}</div>
            <div>Forma de entrega: {{ detail.transport || '-' }}</div>
            <div>Preço com desconto: {{ detail.pay_amount }}</div>
          </div>
          <div class="order-item" v-for="(item,index) in detail.items" :key="index">
            <div>Nome do produto: {{ item.goods_name }}</div>
            <div>Código do produto: {{ item.code || '-' }}</div>
            <div>Quantidade: {{ item.nums }}</div>
          </div>
        </div>
      </div>
      <div class="order-footer">
        <el-button style="margin-top: 20px;" type="primary" @click="copyAndJump">Copie a mensagem e abra o whatsapp para enviar</el-button>
      </div>
    </div>

    <el-dialog title="Forma de entrega" :visible.sync="transportDialogVisible" width="500px">
      <el-form :model="transportForm" label-width="120px" label-position="top">
        <el-form-item label="Forma de entrega">
          <el-input type="textarea" v-model="transportForm.transport" rows="4" placeholder="Digite a forma de entrega"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transportDialogVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="confirmTransport">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getConfig } from '@/api/home'
import Navbar from '@/components/Navbar.vue'
import { orderDetail,updateTransport } from '@/api/order'
import { addCart,getCartNum } from '@/api/cart'



export default {
  name: 'ProductDetailPage',
  components: {
    Navbar
  },
  data() {
    return {
      transportDialogVisible: false,
      transportForm: {
        transport: ''
      },
      form: {
        transport: ''
      },
      rules: {
        transport: [
          { required: true, message: 'Por favor, insira a forma de entrega', trigger: 'blur' }
        ]
      },
      config: {},
      detail: {},
      id: null,
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getConfigInfo();
    //在登录的情况下 是否已经收藏
    if(this.$store.getters['user/isLoggedIn']){
      this.loadDetail()
    }

  },
  methods: {
    getConfigInfo(){
      getConfig().then(res=>{
        this.config = res.data
        // console.log('config',this.config);
      }).catch(err=>{
        console.log('err',err)
      })
    },
    submitForm(){
      updateTransport({
        order_id: this.id,
        transport: this.form.transport
      }).then(res=>{
        // this.loadDetail();
      }).catch(err=>{
        console.log('err',err)
      })
    },
    copyAndJump(){
      if (this.detail.transport) {
        this.doCopyAndOpenWhatsapp(this.detail.transport);
      } else {
        this.transportForm.transport = '';
        this.transportDialogVisible = true;
      }
    },
    doCopyAndOpenWhatsapp(transport){
      const orderSn = this.detail.order_sn;
      const textarea = document.createElement('textarea');
      let orderDetail = `Número do pedido: ${orderSn}\nData do pedido: ${this.detail.create_time}`;
      orderDetail += `\nNome da empresa: ${this.detail.company_name || '-'}\nCNPJ: ${this.detail.tax_number || '-'}\nForma de entrega: ${transport}\nPreço com desconto: ${this.detail.pay_amount}\n`;

      let specList = '';
      this.detail.items.forEach(item => {
        specList += `\nNome do produto: ${item.goods_name}\nCódigo do produto: ${item.code || '-'}\nQuantidade: ${item.nums}\n`;
      });
      textarea.value = orderDetail + specList;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('Informações do pedido copiadas com sucesso');

      let whatsapp = this.detail.whatsapp
      if(!whatsapp){
        whatsapp = this.config.whatsapp
      }
      window.open('https://api.whatsapp.com/send/?phone=' + whatsapp + '&text=' + encodeURIComponent(orderDetail + specList))
    },
    confirmTransport(){
      if (!this.transportForm.transport) {
        return this.$message.error('Por favor, insira a forma de entrega');
      }
      updateTransport({
        order_id: this.id,
        transport: this.transportForm.transport
      }).then(res=>{
        this.transportDialogVisible = false;
        this.detail.transport = this.transportForm.transport;
        this.doCopyAndOpenWhatsapp(this.transportForm.transport);
      }).catch(err=>{
        console.log('err',err)
      })
    },
     getCartNumFun(){
        getCartNum().then(res=>{
          this.cartCount = res.data.num
        }).catch(err=>{
          console.log('err')
        })
      },
    checkFavorite(){
      hasCollect({id: this.goods_id}).then(res => {
        this.collect_id = res.data.collect;
        this.isFavorite = res.data.collect > 0 ? true : false
      }).catch(err=>{
        console.log('err',err)
      })
    },
    specSelect(item,index){
      this.specIndex = index
      this.selectIndex = 0
      this.price = item.price
      this.arr = item.arr;
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    loadDetail() {
      // 模拟从API加载商品数据
      const { id } = this;
      orderDetail({
        id
      }).then(res => {
        this.loading = false;
        this.detail = res.data
        this.form.transport = this.detail.transport || ''
      }).catch(err=>{
        console.log('err',err)
      })


    },

  }
}
</script>

<style lang="scss" scoped>
.order-detail{
  border:1px dotted #ddd;
  padding: 15px;
  border-radius: 6px;
  background: #fff;
  .order-header{
    display: flex;
    padding: 15px 0;
    border-bottom: 1px solid #ddd;
    margin-bottom: 15px;
    >div{
      margin-right: 10px;
    }
  }
  .order-list{
    .order-item{
      margin-bottom: 15px;
      font-size: 13px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

}
.order-footer{
  display: flex;
}
</style>
